import { Area, Floor, Space } from './Map/SetFloorsModal/FloorItem';
import getAreas from '../requests/Locations/Areas/GetAreas';
import getBuildings from '../requests/Locations/Buildings/GetBuildings';
import getSpaces from '../requests/Locations/Spaces/GetSpaces';
import getFloorData from '../requests/Locations/Floors/GetFloorData';
import { Building } from '../screens/LocationManagement/components/AddBuildingModal';

const GetEntireLocationStructure = (setLocations, setEmptyState?) => {
  const locations = {};
  getBuildings()
    .then(async (buildingData: { locations: Building[], isError?: boolean }) => {
      if (buildingData && !buildingData.isError) {
        if (setEmptyState) setEmptyState(buildingData.locations.length > 0);
        const buildingPromises = buildingData.locations
          .sort((prev, next) => prev.Name.localeCompare(next.Name))
          .map(async (building: Building) => {
            const { LocationId: buildingId } = building;
            locations[buildingId] = { ...building, floors: {} };
            const floorData = await getFloorData(buildingId);
            if (floorData && !floorData.isError) {
              const floorPromises = floorData.locations
                .sort((prev, next) => prev.Index - next.Index)
                .map(async (floor: Floor) => {
                  const { LocationId: floorId } = floor;
                  locations[buildingId].floors[floorId] = { ...floor, areas: {} };
                  const areaData = await getAreas(floorId);
                  if (areaData && !areaData.isError) {
                    const areaPromises = areaData.locations
                      .sort((prev, next) => prev.Name.localeCompare(next.Name))
                      .map(async (area: Area) => {
                        const { LocationId: areaId } = area;
                        locations[buildingId].floors[floorId]
                          .areas[areaId] = { ...area, spaces: {} };
                        const spaceData = await getSpaces(areaId);
                        if (spaceData && !spaceData.isError) {
                          spaceData.locations
                            .sort((prev, next) => prev.Name.localeCompare(next.Name))
                            .forEach((space: Space) => {
                              const { LocationId: spaceId } = space;
                              locations[buildingId].floors[floorId]
                                .areas[areaId].spaces[spaceId] = space;
                            });
                        }
                      });
                    await Promise.all(areaPromises);
                  }
                });
              await Promise.all(floorPromises);
            }
          });
        await Promise.all(buildingPromises);
        setLocations({ ...locations });
      } else if (setEmptyState) {
        setEmptyState(null);
      }
    }).catch(() => {
      if (setEmptyState) setEmptyState(null);
    });
};

export default GetEntireLocationStructure;
